const adjectives = [
  "stellar",
  "cosmic",
  "orbital",
  "lunar",
  "solar",
  "astral",
  "galactic",
  "nebula",
  "aurora",
  "quantum",
  "radiant",
  "infinite",
  "blazing",
  "daring",
  "swift",
  "bold",
  "silent",
  "mighty",
  "phantom",
  "ancient",
  "frozen",
  "crimson",
  "golden",
  "amber",
  "violet",
  "cobalt",
  "emerald",
  "obsidian",
  "titan",
  "iron",
  "rapid",
  "brave",
  "fierce",
  "noble",
  "primal",
  "vivid",
  "warp",
  "hyper",
  "turbo",
  "mega",
];

const nouns = [
  "horizon",
  "voyage",
  "drift",
  "pulse",
  "forge",
  "frontier",
  "mission",
  "orbit",
  "beacon",
  "comet",
  "nova",
  "vortex",
  "nebula",
  "atlas",
  "zenith",
  "apex",
  "shuttle",
  "rover",
  "probe",
  "station",
  "gateway",
  "vector",
  "signal",
  "flare",
  "storm",
  "thunder",
  "spark",
  "blaze",
  "trail",
  "quest",
  "path",
  "leap",
  "launch",
  "ascent",
  "surge",
  "strike",
  "rush",
  "dash",
  "bolt",
  "wave",
];

export function generateCanvasName(): string {
  const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  return `${adj}-${noun}`;
}
